import { SELECT_BOAT, UPDATE_BOAT_RATING } from '../actions/types';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_BOAT:
      return action.payload !== undefined ? action.payload : state;
    case UPDATE_BOAT_RATING:
      // If the currently selected boat is the one being updated, merge the new rating data.
      return state && state.uid === action.payload.boatId ? { ...state, ...action.payload.ratingData } : state;
    default:
      return state;
  }
};
